'use client';

import React from 'react';
import { Modal } from '../antd-wrapper/modal/global/modal';
import { useI18n } from '@/hooks/use-i18n';

interface DeleteConfirmationDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  threadName: string;
  isDeleting: boolean;
}

export function DeleteConfirmationDialog({
  isOpen,
  onClose,
  onConfirm,
  threadName,
  isDeleting,
}: DeleteConfirmationDialogProps) {
  const { t } = useI18n(['thread', 'common']);

  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      onOk={onConfirm}
      title={t('thread:deleteConfirmation.title')}
      okText={t('common:delete')}
      okButtonProps={{
        loading: isDeleting,
      }}
      cancelText={t('common:cancel')}
      closable={!isDeleting}
      maskClosable={!isDeleting}
      height={228}
    >
      <div className="px-[24px] h-full flex items-center justify-center">
        <div>
          {t('thread:deleteConfirmation.message')}{' '}
          <span className="font-semibold">"{threadName}"</span> ?
          <div className="mt-3 text-sm text-gray-600">
            {t('thread:deleteConfirmation.cannotUndo')}
          </div>
        </div>
      </div>
    </Modal>
  );
}
